export interface Param<T> {
  decode: (s: string) => T
  encode: (x: T) => string
  // Optional validator used during matching to decide if a param should be considered a match.
  // If provided and returns false for a raw string value, the route will not match and will fall through.
  isValid?: (s: string) => boolean
}

export function TypedParam<T extends string>(): Param<T> {
  return {
    decode: (s) => s as T,
    encode: (s) => s
  }
}

export const StringParam = TypedParam<string>()

export const IntParam: Param<number> = {
  decode: (s) => parseInt(s),
  encode: (x) => x.toString()
}

export const BooleanParam: Param<boolean> = {
  decode: (s) => s === 'true',
  encode: (b) => b.toString()
}

export const Base64Param: Param<string> = {
  encode: base64EncodeURL,
  decode: base64DecodeURL
}

export const RawParam = TypedParam<string>()

function base64EncodeURL(plain: string): string {
  // Node / bundler with Buffer polyfill
  if (typeof Buffer !== 'undefined') return Buffer.from(plain, 'utf8').toString('base64url')

  // Browser
  return btoa(unescape(encodeURIComponent(plain)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

function base64DecodeURL(b64url: string): string {
  if (typeof Buffer !== 'undefined') return Buffer.from(b64url, 'base64url').toString('utf8')

  const padded = b64url.padEnd(b64url.length + ((4 - (b64url.length % 4)) % 4), '=')
  const base64 = padded.replace(/-/g, '+').replace(/_/g, '/')
  return decodeURIComponent(escape(atob(base64)))
}
